import React from 'react';
import { Box, IconButton } from '@mui/material';
import closeIcon from '../../assets/icons/close.svg';

const DetailsPanel = ({ 
  children, 
  onClose, 
  width = '25%', 
  minWidth = '600px',
  backgroundColor = '#F9FAFC',
  showCloseButton = true 
}) => {
  return (
    <>
      {/* Background Overlay */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1400,
          cursor: 'pointer'
        }}
        onClick={onClose}
      />
      
      {/* Panel */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: width,
          minWidth: minWidth,
          height: '100vh',
          backgroundColor: backgroundColor,
          boxShadow: '0px 20px 80px #00000011',
          zIndex: 1500,
          overflowY: 'auto',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
      {/* Close Button */}
      {showCloseButton && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
          <IconButton onClick={onClose} sx={{ padding: 0 }}>
            <img src={closeIcon} alt="Fermer" style={{ width: '24px', height: '24px' }} />
          </IconButton>
        </Box>
      )}

      {/* Main Content - Takes up available space */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </Box>
    </>
  );
};

export default DetailsPanel;
